import {COLORS, SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const Skeleton = () => {
  return (
    <TitleSection>
      <SkeletonBlock $width="65%" />
      <SkeletonBlock $width="40%" />
      <SkeletonBlock $width="38%" />
    </TitleSection>
  );
};

const TitleSection = styled.section`
  align-items: center;
  border-bottom: 1px solid ${COLORS.Grey3};
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 0 1rem;
`;
